export const FORGOT_PASSWORD = 'events/FORGOT_PASSWORD';

/**
 * @param login
 * @return {{type: string, payload: {login:*}}}
 */
export const forgotPassword = (login) => ({
  type: FORGOT_PASSWORD,
  payload: { login },
});
